import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  appdataSelector,
  appdata_setActiveRequestID,
  appdata_setActiveRequestState,
  appdata_setActiveRequestType,
  appdata_setIsRequestRequest
} from "reducers/appdata/appdata";
import {
  vendordata_clearAllVendorData,
  vendordata_getVendorDataForRequest,
  vendordata_setSavedToSAP,
  vendordataSelector
} from "reducers/vendordata/vendordata";
import Header from "./Header";
import FileViewer from "components/MediaTel/FileViewer";
import VendordataNonEditable from "./VendorDataNonEditable";
import VendordataEditable from "./VendordataEditable";
import Loader from "components/Loading/Loader";
import Approvers from "./Approvers";
import { checkValidity } from "./VendordataHelper";
import { getUser } from "services/auth";
import HeaderEditable from "./HeaderEditable";



function RequestDetails() {
  const params = useParams();
  const dispatch = useDispatch();
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    console.log("NEW REQUEST DETAIL VIEW ", appdata.isResetRequest);

    if (!appdata.isResetRequest) {
      dispatch(vendordata_clearAllVendorData());
    }
    // get request id from params
    dispatch(appdata_setActiveRequestID(params.reqID));

    dispatch(vendordata_getVendorDataForRequest(params.reqID));


  }, []);

  useEffect(() => {

    if (vendordata.approvers && getUser()) {
      Object.keys(vendordata.approvers).map(key => {
        if (vendordata.approvers[key].SIG_NUM == "001") {
          // one of the first approvers
          if (parseInt(vendordata.approvers[key].SIG_EMP) == parseInt(getUser().employeeId)) {
            // one of the first approvers is actually the current user
            if (vendordata.approvers[key].SIG_STAT == "" && vendordata.activeVendor && vendordata.activeVendor.master && vendordata.activeVendor.master.BACK_2_REQUESTOR != "X") {
              // the currentuser has not approved yet, allow edit
              if (!editable)
                setEditable(true);
              if (vendordata.savedToSAP) {
                dispatch(vendordata_setSavedToSAP(false));
              }
            }
            else {
              if (editable)
                setEditable(false);
            }
          }
        }
      })
    }


  }, [vendordata.approvers])

  useEffect(() => {
    console.log("vendordata updated", vendordata);

    if (vendordata.activeVendor && vendordata.activeVendor.master) {
      if (vendordata.activeVendor.master.IS_REQUESTOR && vendordata.activeVendor.master.BACK_2_REQUESTOR) {
        if (!appdata.isResetRequest)
          dispatch(appdata_setIsRequestRequest(true))
      }
    }

    if (vendordata.activeVendor.master) {

      // check and set type
      let requestType = vendordata.activeVendor.master.REQ_TYP;


      /* let activeRequestType = Object.keys(appdata.requestTypes).find(
        key => appdata.requestTypes[key] === requestType
      ); */

      if (appdata.activeRequestType != requestType) {
        dispatch(appdata_setActiveRequestType(requestType));
      }

      if (!appdata.isResetRequest && appdata.activeRequestState != appdata.requestStates.ADJUST) {
        dispatch(appdata_setActiveRequestState(appdata.requestStates.ADJUST));
      }

      if (appdata.isResetRequest && appdata.activeRequestState != appdata.requestStates.CREATE) {
        dispatch(appdata_setActiveRequestState(appdata.requestStates.CREATE));
      }
    }

    if (vendordata.approvers && getUser() && !editable) {
      Object.keys(vendordata.approvers).map(key => {
        if (vendordata.approvers[key].SIG_NUM == "001") {
          // one of the first approvers
          if (parseInt(vendordata.approvers[key].SIG_EMP) == parseInt(getUser().employeeId)) {
            // one of the first approvers is actually the current user
            if (vendordata.approvers[key].SIG_STAT == "" && vendordata.activeVendor && vendordata.activeVendor.master && vendordata.activeVendor.master.BACK_2_REQUESTOR != "X") {
              // the currentuser has not approved yet, allow edit
              setEditable(true);
            }
          }
        }
      })
    }


    checkValidity(vendordata, dispatch);



  }, [vendordata]);


  if (!vendordata.activeVendor.master
    || !appdata.listvalues
    || !appdata.activeRequestID
    || !getUser().employeeId
    || vendordata.loading) {
    return <div className="d-flex flex-column justify-content-center align-items-center h-100">
      <div className="row">
        <div className="col-12">
          <Loader></Loader>
        </div>
      </div>

      <div className="row">
        <div className="col-12">Loading Request {appdata.activeRequestID ? appdata.activeRequestID : ""}</div>
      </div>

    </div>;
  }

  return (
    <article className="article">
      <div className="container-fluid no-breadcrumb chapter">
        <h2 className="article-title">Request {appdata.activeRequestID}</h2>



        {/* editable header for resetted request */}
        {/* editable header for resetted request */}
        {/* editable header for resetted request */}
        {/* editable header for resetted request */}
        {appdata.isResetRequest && <HeaderEditable></HeaderEditable>}


        {/* header */}
        {/* header */}
        {/* header */}
        {/* header */}
        {/* header */}
        {!appdata.isResetRequest && (
          <React.Fragment>
            <Header></Header>


            <FileViewer enableDownload={true}></FileViewer>

            {/* non editable vendordata */}
            {/* non editable vendordata */}
            {/* non editable vendordata */}
            {/* non editable vendordata */}
            {!editable && <VendordataNonEditable></VendordataNonEditable>}

            {/* editable vendordata */}
            {/* editable vendordata */}
            {/* editable vendordata */}
            {/* editable vendordata */}
            {/* editable vendordata */}
            {editable && <VendordataEditable></VendordataEditable>}

            <hr></hr>

            {/* aprovers */}
            {/* aprovers */}
            {/* aprovers */}
            {/* aprovers */}
            {vendordata.approvers && (
              <Approvers></Approvers>
            )}
          </React.Fragment>
        )}
      </div>
    </article>
  );
}

export default RequestDetails;







